import ToastMessageControllerImpl from './toast-message-controller.js';
import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import PropTypes from 'prop-types';
const { UIView } = MojitoCore.Presentation;
const { SHOW_SIMPLE_TOAST } = MojitoServices.Messaging.types.INCOMING_MESSAGES;

/**
 * Module that displays simple toast messages for player.
 *
 * @class ToastMessageController
 * @name module
 * @memberof Mojito.Modules.PlayerMessages.ToastMessage
 */

/**
 * Callback function fired on user interaction with the toast.
 * Typically on click.
 *
 * @callback actionCallback
 * @param {Mojito.Services.Messaging.types.Message} message - Toast message object.
 * @memberof Mojito.Modules.PlayerMessages.ToastMessage.module
 */

/**
 * ToastMessageController prop types.
 *
 * @property {Mojito.Services.Messaging.types.INCOMING_MESSAGES} [toastMessageType = Mojito.Services.Messaging.types.INCOMING_MESSAGES.SHOW_SIMPLE_TOAST] - Toast message type that will be used to grab messages from store.
 *
 * @memberof Mojito.Modules.PlayerMessages.ToastMessage.module
 */
const propTypes = {
    toastMessageType: PropTypes.oneOf(Object.values([SHOW_SIMPLE_TOAST])),
};

const defaultProps = {
    toastMessageType: SHOW_SIMPLE_TOAST,
};

export default UIView(
    'ToastMessageController',
    ToastMessageControllerImpl,
    propTypes,
    defaultProps
);
